import React, { useEffect, useState } from 'react';
import { Store, Power } from 'lucide-react';
import api from '../api/client';

interface Shop {
  id: number;
  name: string;
  address: string;
  phone: string;
  owner: number;
  owner_name: string;
  owner_phone: string;
  is_active: boolean;
  created_at: string;
}

export const Shops: React.FC = () => {
  const [shops, setShops] = useState<Shop[]>([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState<number | null>(null);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get('/shops/');
      setShops(res.data.results ?? res.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const toggleActive = async (shop: Shop) => {
    setBusyId(shop.id);
    try {
      await api.patch(`/shops/${shop.id}/`, { is_active: !shop.is_active });
      await load();
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Do'konlar</h1>

      {loading ? (
        <div className="text-center py-12 text-gray-500">Yuklanmoqda...</div>
      ) : shops.length === 0 ? (
        <div className="text-center py-12 text-gray-500">Do'kon yo'q</div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {shops.map((shop) => (
            <div key={shop.id} className="card">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                  <div className="bg-primary-100 p-2 rounded-lg">
                    <Store className="w-5 h-5 text-primary-800" />
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{shop.name}</div>
                    <div className="text-xs text-gray-500">{shop.phone || '—'}</div>
                  </div>
                </div>
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                    shop.is_active ? 'bg-success-100 text-success-700' : 'bg-gray-200 text-gray-600'
                  }`}
                >
                  {shop.is_active ? 'Faol' : 'Faol emas'}
                </span>
              </div>
              <div className="text-sm text-gray-600 mt-3">
                <div>Egasi: {shop.owner_name}</div>
                <div>{shop.owner_phone}</div>
                {shop.address && <div className="mt-1 text-gray-500">{shop.address}</div>}
              </div>
              <button
                onClick={() => toggleActive(shop)}
                disabled={busyId === shop.id}
                className={`btn mt-4 w-full flex items-center justify-center gap-2 ${
                  shop.is_active ? 'btn-secondary' : 'btn-primary'
                }`}
              >
                <Power className="w-4 h-4" />
                {shop.is_active ? "Faolsizlantirish" : 'Faollashtirish'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
